<template>
  <vs-popup title="Your guest consent link" :active.sync="isActive">
    <div style="min-height: 300px" class="flex flex-col">
      <div>
        <div class="mb-2">
          Select a venue to create your guest consent link
        </div>
        <venue-selector
          :filterCountries="['Denmark']"
          v-model="selectedVenueId"
          v-on:venue="(v) => (selectedVenue = v)"
        />
      </div>

      <Loading v-if="selectedVenueId && !shortLink" />
      <div v-if="selectedVenueId && shortLink" class="mt-6">
        <div class="mb-2">Your consent link</div>
        <vs-textarea
          class="w-full"
          rows="9"
          placeholder="Personal link"
          v-model="linkText"
        ></vs-textarea>

        <div class="flex justify-center pt-4">
          <vs-button @click="copyTextToClipBoard" icon="content_paste"
            >Copy text</vs-button
          >
          <!-- <vs-button @click="createShortLink" class="ml-3" icon="link">Shorten link</vs-button> -->
        </div>
        <!-- 
        <div class="mb-2" v-if="shortLink">Shortened link</div>
        <vs-input
          v-if="shortLink"
          class="w-full"
          placeholder="Personal short link"
          v-model="shortLink"
        ></vs-input>

        <div class="flex justify-center pt-4" v-if="shortLink">
          <vs-button @click="copyShortToClipboard" icon="content_paste">Copy short link</vs-button>
        </div> -->
      </div>
    </div>
  </vs-popup>
</template>

<script>
import { mapGetters } from "vuex";
import VenueSelector from "@/components/VenueSelector.vue";

export default {
  components: { VenueSelector },
  data() {
    return {
      isActive: false,
      shortLink: "",
      selectedVenue: null,
      selectedVenueId: null,
    };
  },
  watch: {
    selectedVenueId: function (newVal, oldVal) {
      if (newVal) {
        this.createShortLink();
      }
    },
  },
  methods: {
    show() {
      this.isActive = true;
    },
    createShortLink() {
      this.shortLink = "";
      /* const nameShorten = this.$AuthService
        .getUser()
        .name.split(" ")
        .map((n) => n[0])
        .join(""); */

      const dto = {
        url: this.link,
        venueName: this.selectedVenue.shortName.toLowerCase().replace(" ", ""),
      };

      this.$store
        .dispatch("guestProfiles/shortenReferralUrl", dto)
        .then((e) => {
          this.shortLink = e.shortURL;
          // this.useShortLink = true;
        })
        .catch((err) => {
          console.log("Link shorten error:", err);
          this.shortLink = this.link;
        });
    },
    // copyLongToClipboard() {
    //   this.copyToClipboard(this.link);
    // },
    // copyShortToClipboard() {
    //   this.copyToClipboard(this.shortLink);
    // },

    copyTextToClipBoard() {
      this.copyToClipboard(this.linkText);
    },
    copyToClipboard(text) {
      if (!navigator.clipboard) {
        return;
      }

      navigator.clipboard.writeText(text).then(
        function () {
          console.log("Async: Copying to clipboard was successful!");
        },
        function (err) {
          console.error("Async: Could not copy text: ", err);
        }
      );
    },
  },
  computed: {
    ...mapGetters({
      userId: "users/userId",
      me: "users/me",
    }),
    linkText() {
      return `Hej!\n\nJeg arbejder for ${this.selectedVenue.venueName} og vil gerne i kontakt med dig.\n\nHvis du er interesseret i at høre mere skal du signe up og acceptere vores betingelser. Du kan finde dem her: ${this.shortLink}\n\nMvh ${this.me.firstName} ${this.me.lastName}`;

      // return `Hej,\nFor, at vi kan tale videre skal jeg først have dig til at acceptere vores GDPR betingelser. Du kan finde dem her: ${
      //   this.useShortLink ? this.shortLink : this.link
      // }\nJeg kan desværre ikke hjælpe dig videre herfra, medmindre de er accepteret. Håber det er o.k. med dig :)`;
    },
    link() {
      return `https://compliance.rekom.dk/${this.userId}/${this.selectedVenueId}`;
    },
  },
};
</script>
